<script lang="ts">
  import 'bootstrap/js/dist/modal';
  import { createEventDispatcher } from 'svelte';
  import { getAppConfig } from '../../../common/config/app-config';
  import { getContextedUrl, getStr, globalCurrencyTag } from '../../../common/util';
  import Text from '../../../modules/common/components/Text.svelte';
  import Icon from '../../common/components/Icon.svelte';
  import Tag from '../../common/components/tag/Tag.svelte';

  export let gift;
  export let selectedGiftsGroups;
  export let index;
  export let isFixedGift;
  export let selectedGifts;
  export let activeGroup;
  const { lang } = getAppConfig();
  export let isModel: boolean = true;

  let dispatch = createEventDispatcher();
  function handleGiftCheckbox(event) {
    dispatch('handleGiftCheckbox', {
      e: event,
      gift: gift,
      index: index,
    });
  }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
{#each gift.freeGiftProducts as item}
  <label for={`${item.code}~${index}`} class="custom-checkbox cb2">
    <div
      class="card-container js-free-gift-card-container"
      class:selected={selectedGiftsGroups[index].includes(item.code)}
      class:c_preorder-giftitem={!isModel}
      class:c_preorder-giftitem-oos={!isModel && item?.stock?.stockLevelStatus?.code === 'outOfStock'}
    >
      <div class="gift-option-card">
        <div class="gift-option-main">
          <div class="free-gift-product-img">
            <img src={item?.amplienceProductBaseUrl} alt="" />
          </div>
          <div class="product-description">
            <span class="item-name">{item?.name}</span>
            {#if isModel}
              <a href={getContextedUrl(item?.url)}>
                {getStr('extra.pdp.gift.options.product.details')}
                <Icon glyph={lang === 'en' ? 'chevron_right' : 'chevron_left'} desktopSize={16} mobileSize={16} />
              </a>
            {/if}
          </div>
        </div>
        <div class="gift-option-meta">
          <div class="gift-price-copy">
            <div class="free-label"><Text key="extra.pdp.gift.price.free.message" /></div>
            <div class="striked-price">
              <Text key="jood.price.with.currency" args={[globalCurrencyTag, item?.price?.formattedValue]} />
            </div>
          </div>
          {#if item?.stock?.stockLevelStatus?.code !== 'outOfStock'}
            {#if !isFixedGift}
              <div class="selection-box">
                {#if isModel}
                  <input
                    id={`${item.code}~${index}`}
                    type="checkbox"
                    name="fgProductCodes"
                    class:selected={selectedGiftsGroups?.length > 0 &&
                      selectedGiftsGroups?.[index]?.includes(item.code)}
                    disabled={isFixedGift ||
                      (activeGroup !== index && activeGroup !== -1) ||
                      (!selectedGiftsGroups[index].includes(item.code) &&
                        selectedGiftsGroups[index].length == gift.freeGiftQtuantities.sourceQty)}
                    bind:group={$selectedGifts}
                    value={`${item.code}~${index}`}
                    on:change={event => handleGiftCheckbox(event)}
                  />
                {:else}
                  <input
                    id={`${item.code}~${index}`}
                    type="checkbox"
                    name="fgProductCodes"
                    class:selected={selectedGiftsGroups?.length > 0 &&
                      selectedGiftsGroups?.[index]?.includes(item.code)}
                    disabled={isFixedGift}
                    bind:group={$selectedGifts}
                    value={`${item.code}~${index}`}
                    on:change={event => handleGiftCheckbox(event)}
                  />
                {/if}

                <span class="chkbx" />
              </div>
            {/if}
          {/if}
          {#if item?.stock?.stockLevelStatus?.code === 'outOfStock'}
            <div class="oos-container">
              <Tag label="Out of stock" backgroundColorCode="#E1EDF4" textColorCode="#81939E" />
            </div>
          {/if}
        </div>
      </div>
    </div>
  </label>
{/each}

<style lang="scss">
  @import '../../common/styles/colors.new.scss';
  .free-gift-product-img {
    min-width: 74px;
    height: 74px;
    display: flex;
    justify-content: center;
    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }
  .card-container {
    border: 1px solid $secondary-gray-02;
    border-radius: 10px;
    background: $primary-white;
    transition:
      border-color 160ms ease,
      box-shadow 160ms ease;
    margin-bottom: 8px;
    &.selected {
      border-color: $icon-only-icon-blue;
      box-shadow: 0 0 0 1px rgba(0, 122, 255, 0.08);
    }
    @include desktop-max-width {
      margin-bottom: 8px;
    }
  }
  .gift-option-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 20.5px 16px;
  }

  .gift-option-main {
    display: flex;
    align-items: center;
    gap: 16px;
    min-width: 0;
    flex: 1;
  }

  .custom-checkbox {
    display: block;
    width: 100%;
    .selection-box {
      text-align: end;

      input {
        display: none;
      }
      span.chkbx {
        border: 2px solid #d3dce5;
        border-radius: 6px;
        height: 24px;
        width: 24px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 10px;
        color: $primary-white;
        transition:
          background-color 160ms ease,
          border-color 160ms ease;
      }
      input:checked + span.chkbx:before {
        content: '✔';
      }
      input:checked + span.chkbx {
        background: $icon-only-icon-blue;
        border-color: $icon-only-icon-blue;
      }
      input:disabled + span.chkbx {
        cursor: not-allowed;
        opacity: 0.7;
      }
    }
  }

  .product-description {
    min-width: 0;
    .item-name {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 20px;
      line-height: 20px;
      font-weight: 500;
      color: $neutral-dark-02;
    }
    a {
      margin-top: 12px;
      color: $primary-blue;
      font-weight: 500;
      font-size: 17px;
      line-height: 14px;
      &:hover {
        color: $icon-only-icon-blue;
      }
      display: flex;
      gap: 4px;
      align-items: center;
    }
  }

  .gift-option-meta {
    display: flex;
    align-items: center;
    gap: 38px;
    flex-shrink: 0;
  }

  .gift-price-copy {
    text-align: right;
  }

  .free-label {
    color: $functional-green-01;
    font-size: 18px;
    line-height: 16px;
    font-weight: 700;
  }

  .striked-price {
    margin-top: 4px;
    color: $neutral-dark-04;
    font-size: 16px;
    line-height: 12px;
    text-decoration: line-through;
  }

  .oos-container {
    display: flex;
    justify-content: end;
  }

  @include desktop-max-width {
    .card-container {
      border-radius: 10px;
      margin-bottom: 10px;
    }
    .gift-option-card {
      padding: 1.5px 16px;
    }
    .gift-option-main {
      gap: 14px;
      align-items: center;
    }
    .free-gift-product-img {
      min-width: 64px;
      height: 64px;
    }
    .product-description .item-name {
      font-size: 14px;
      line-height: 16px;
      font-weight: 400;
    }
    .product-description a {
      margin-top: 8px;
      font-size: 12px;
      line-height: 14px;
      font-weight: 500;
    }
    .gift-option-meta {
      flex-direction: column-reverse;
      align-items: flex-end;
      gap: 8px;
      min-width: 44px;
    }
    .gift-price-copy {
      text-align: right;
    }
    .free-label {
      font-size: 14px;
      line-height: 16px;
    }
    .striked-price {
      margin-top: 2px;
      font-size: 12px;
      line-height: 14px;
    }
    .selection-box .custom-checkbox span {
      height: 18px;
      width: 18px;
      border-width: 2px;
      border-radius: 4px;
    }
    .selection-box {
      padding: 3px;
      label {
        display: block;
      }
    }
  }
</style>
